import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { ViewComponent } from 'src/app/core/view/view.component';
import { LoginService } from 'src/app/login/login.service';
import { UsersService } from 'src/app/users/users.service';
import { EntitiesService } from '../../entities.service';
import { RolesService } from '../../roles/roles.service';
import { ZonesService } from '../../zones/zones.service';
import { HtmlPreviewComponent } from '../html-preview/html-preview.component';
import { TemplatesTypesService } from '../templates-types.service';
import { TemplatesService } from '../templates.service';
import { timeout } from 'rxjs';
import { BeeService } from '../../../core/bee.service';
import { ViewsService } from '../../../core/view/views.service';
import { CoreFormService } from '../../../core/forms/core-forms.service';
import { NgForm } from '@angular/forms';
import { TinyMCE } from 'tinymce';
import { TranslateService } from '@ngx-translate/core';
import { options } from '@fullcalendar/core/preact';

@Component({
  selector: 'app-templates-detail',
  templateUrl: './templates-detail.component.html',
  styleUrls: ['./templates-detail.component.scss']
})
export class TemplatesDetailComponent implements OnInit {

  @ViewChild("formDetails") public formDetails: NgForm;
  @ViewChild("view") public view: ViewComponent;

  tinyMceConfig: any;

  public showTinyMCE: boolean = false;

  public template: any = {};
  public users: any[] = [];
  public zones: any[] = [];
  public roles: any[] = [];
  public selected_zone: any;
  public selected_zones: any[] = [];
  public selected_user: any;
  public selected_users: any[] = [];
  public selected_role: any;
  public selected_roles: any[] = [];

  public templateTypes: any[];
  public selectedTemplateType:any = {};
  public entities: any[];

  public zonesPermission: any;

  constructor(
    private templatesService: TemplatesService,
    private zonesService: ZonesService,
    private usersService: UsersService,
    private rolesService: RolesService,
    private templateTypesService: TemplatesTypesService,
    private entitiesService: EntitiesService,
    private loginService: LoginService,
    private coreFormService: CoreFormService,
    private coreDialogService: CoreDialogService,
    private dynamicDialogRef: DynamicDialogRef,
    private messageService: MessageService,
    private config: DynamicDialogConfig,
    private dialogService: DialogService,
    private beeService: BeeService,
    private viewsService: ViewsService,
    private translateService: TranslateService
  ) {

  }

  ngOnInit(): void {

    this.zonesPermission = this.loginService.hasPermission("ZONES_READ");
    this.loadTemplateTypes();
    //if (!id) {
    this.loadEntities();
    //}

    //this.loadData(id);



    //this.configureTinyMce("entities/variables?entity_id=3");
    // this.preConfigTinyMce();

  }

  load(id) {
    if (id) {
      this.templatesService.get(id).subscribe({
        next: (data: any) => {
          this.template = data;

          //si es de tipo documento y no tiene <header> ni <footer> lo añadimos.
          if(this.template.beeplugin == false){
            if (this.template.templatetype?.code == "DOCUMENT") {
              if (!this.template.html.includes("<main")) {
                this.template.html = "<main class='editable'>" + this.template.html + "</main>";
              }
              if (!this.template.html.includes("<header")) {
                this.template.html = "<header class='editable'></header>" + this.template.html;
              }
              if (!this.template.html.includes("<footer")) {
                this.template.html = this.template.html + "<footer class='editable'></footer>";
              }
            }/*else {
              if (!this.template.html.includes("<main")) {
                this.template.html = "<main class='editable'>" + this.template.html + "</main>";
              }
            }*/
          }

          if (!this.template.beeplugin) {
            this.configureTinyMce("entities/variables?entity_id=" + this.template.entity_id);
          } else {
            this.configureBee("entities/variables?entity_id=" + this.template.entity_id);
          }

          this.loadMetadata();
          
          setTimeout( () => {
            this.onTemplateTypeChange();
          }, 500);
        },
        error: (error: any) => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      });
    } else {
      this.template.template_type_id = this.config.data.template_type_id;
      var default_entity = this.entities.find(entity => entity.code == "contact");
      var default_template_type = this.templateTypes.find(template => template.code == "MAIL");

      this.template.entity_id = default_entity.id;
      this.template.template_type_id = default_template_type.id;
      this.beeService.start({}, null, null);
    }
  }

  preConfigTinyMce() {

    const that = this;
    this.tinyMceConfig =
    {
      selector: 'textarea',
      promotion: false,
      height: 500,
      menubar: true,
      browser_spellcheck: true,
      contextmenu: false,
      plugins: [
        /*'preview',*/
        /*'formatpainter'*/
        'quickbars',
        'pagebreak'
      ],
      quickbars_insert_toolbar: "quicktable",
      toolbar: [
        'previewButton | undo redo | bold italic underline | fontselect fontsizeselect fontsize blocks fontfamily  formatselect |' +
        'alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist checklist | pagebreak |' +
        'forecolor casechange permanentpen formatpainter removeformat | fullscreen | insertfile image media pageembed link | table quickbars | variablesButton  variablesLinesButton |'
      ],
      pagebreak_separator: '<!-- pagebreak -->',
      fontsize_formats: "8px 9px 10px 11px 12px 13px 14px 15px 16px 17px 18px 19px 20px 21px 22px 23px 24px 30px 36px 38px 40px",

      content_css: "../assets/stylesTinymceCustom.css",
      body_class: "",
      noneditable_noneditable_class: "mceNonEditable",
      format_noneditable_selector: ".mceNonEditable",
      editable_root: false,
      editable_class: 'editable',
      toolbar_mode: 'wrap',
      language: 'es',
      language_url: '/assets/tinymce/langs/es.js',
      relative_urls: false,
      remove_script_host: false,
      document_base_url: location.protocol + '//' + location.host + '/', //'https://app.axialcrm.com/',
      file_picker_types: 'image',
      paste_data_images: false,

      //configuracion de tablas
      table_sizing_mode: 'relative', //los anchos se ajustan como %
      table_default_styles: {
        width: '100%' //por defecto ocupa el 100%
      },

      /* and here's our custom image picker*/
      onRemove: function () {
      },
      file_picker_callback: function (cb, value, meta) {
        var input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');

        input.onchange = function (e) {
          var file = e.target["files"][0];
          var reader = new FileReader();
          reader.onload = (event: any) => {
            //tenemos la url en base64. creamos el attachment
            //that.onBasicUpload(file, event.target.result);
            var datafile = {
              FileName: file.name,
              ContentType: file.type,
              Length: file.size,
              b64: event.target.result
            };
            that.templatesService.UploadImage(datafile).subscribe({
              next: (data: any) => {
                cb(data.location);
                //FALTA Pintar la imagen con la url en el visor.... work in progress
              },
              error: (error: any) => {
                that.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
              }
            });
          };
          reader.readAsDataURL(file);
        };

        input.click();
      },
    };

  }
  onChangeName() {
    if (this.template.id == null) this.template.subject = this.template.name;
  }

  configureTinyMce(url) {
    this.preConfigTinyMce();
    let params = "";
    const that = this;
    this.viewsService.getComboOptions(url).subscribe(
      data => {
        let result = data;
        let showLinesTransaction = false;
        result.forEach(element => {
          if (element.entity_navigation == "transactionsLines") showLinesTransaction = true;
        });

        //si es pdf, añadimos bloque de cabecera y pie de pagina con variables de paginacion
        if(this.template.templatetype?.code == "DOCUMENT") {
          let headerFooterVariables = {
            entity_name: this.translateService.instant('component.templates.detail.pagination'),
            options: [
              {
                text: this.translateService.instant('component.templates.detail.variables.page'),
                action: "<span class=\"mceNonEditable\">@Page</span>"
              },
              {
                text: this.translateService.instant('component.templates.detail.variables.total_pages'),
                action: "<span class=\"mceNonEditable\">@ToPage</span>"
              }
            ]
          };
          result.push(headerFooterVariables);
        }
        console.log(result);

        this.tinyMceConfig["setup"] = function (editor) {

          let toggleState = false;
          /* example, adding a toolbar menu button */
          editor.ui.registry.addButton('previewButton', {
            text: that.translateService.instant('component.templates.detail.previewed'),
            onAction: function () {
              that.previewHTML();
            }
          })
          editor.ui.registry.addMenuButton('variablesButton', {
            text: that.translateService.instant('component.templates.detail.variables'),
            fetch: function (callback) {
              let items = [];
              result.forEach(element => {
                items.push({
                  type: 'nestedmenuitem',
                  text: element.entity_name,
                  getSubmenuItems: function () {
                    let aux = [];
                    element.options.forEach(option => {
                      aux.push({
                        type: 'menuitem',
                        text: option.text,
                        //icon: 'unlock',
                        onAction: function () {
                          editor.insertContent(option.action);
                        }
                      })
                    });
                    return aux;
                  }
                });
              });
              callback(items);
            }
          });
          if (showLinesTransaction) {
            editor.ui.registry.addButton('variablesLinesButton', {
              text: that.translateService.instant('component.templates.detail.add_lines_block'),
              onAction: function () {
                //that.addForeach()
                //editor.insertContent('<p class="bucle mceNonEditable">@foreach(var item in @Model.transactionsLines){</p><table style=\"border-collapse: collapse; width: 100%;\" border=\"1\">\n<tbody>\n<tr>\n<td></td></tr>\n</tbody>\n</table><p class="bucle mceNonEditable">}</p>', { format: 'html' });
                editor.insertContent(`<table style=\"border: collapse; width: 100%;\">
                                        <thead>
                                          <tr>
                                            <th style="text-align: left;">Descripción</th>
                                            <th style="text-align: right; width: 120px;">Cantidad</th>
                                            <th style="text-align: right; width: 120px;">Precio</th>
                                            <th style="text-align: right; width: 120px;">Importe</th>
                                          </tr>
                                        </thead>
                                        <tbody class='foreach-lines'>
                                          <tr>
                                            <td><span class="mceNonEditable" contenteditable="false">@item.description</span></td>
                                            <td><span class="mceNonEditable" contenteditable="false">@item.qty</span></td>
                                            <td><span class="mceNonEditable" contenteditable="false">@item.net_price</span></td>
                                            <td><span class="mceNonEditable" contenteditable="false">@item.base_amount</span></td>
                                          </tr>
                                        </tbody>
                                      </table>`, { format: 'html' });
              }
            })
          }
        };
        this.showTinyMCE = true;
      }
    );

  }

  loadTemplateTypes() {
    this.templateTypesService.all({}).subscribe(
      data => {
        this.templateTypes = data.rows;
        if (this.templateTypes.length > 0 && this.template.id == null) {
          this.template.template_type_id = this.templateTypes[0].id;
          this.template.templatetype = this.templateTypes[0];
        }
        //this.onTemplateTypeChange();
      }, error => {
        this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
      }
    );
  }

  onTemplateTypeChange() {
    this.selectedTemplateType = this.templateTypes.find(template => template.id == this.template.template_type_id);
  }

  loadEntities() {
    this.entitiesService.all({}).subscribe({
      next: (data: any) => {
        this.entities = data.rows;
        if (this.entities.length > 0 && this.template.id == null) {
          this.template.entity_id = this.entities[1].id;
        }
        this.load(this.config.data.id);
      }, error: (error: any) => {
        this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
      }
    });
  }

  configureBee(url) {
    this.viewsService.getComboOptions(url).subscribe(
      variables => {
        var mergeTags = [];
        var specialLinks = [];
        variables.forEach((item: any) => {
          item.options.forEach(option => {
            mergeTags.push({
              name: item.entity_name + " - " + option.text,
              value: option.actionBlocks
            });
          });
        });

        if (this.template.beeplugin) {
          console.log(this.template.templatetype.code);
          if (this.template.json != null) {
            this.beeService.start(JSON.parse(this.template.json), mergeTags, [], this.template.templatetype.code == 'DOCUMENT'? false: true);
          } else {
            this.beeService.start({}, mergeTags, []);
          }

        }
      });
  }
  

  saveDb(event: any) {
    this.buildMetadata();

    if (!this.template.html) {
      this.template.html = "<p></p>";
    }
    if (typeof this.template.id === "undefined") {
      this.template.is_default = 0;
      this.templatesService.add(this.template).subscribe({
        next: (data: any) => {
          this.template = data;

          this.load(this.template.id);
          this.messageService.add({ closable: false, severity: 'success', summary: this.translateService.instant('component.templates.detail.add_correct') });
        },
        error: (error: any) => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      })
    } else {
      this.templatesService.save(this.template.id, this.template).subscribe({
        next: (data: any) => {
          this.messageService.add({ closable: false, severity: "success", detail: this.translateService.instant('component.templates.detail.save_correct') });
          //this.cancel();
        },
        error: (error: any) => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      })
    }
  }
  save(event: any) {

    if (this.coreFormService.validate(this.formDetails)) {
      if (this.template.id && this.template.beeplugin) {
        this.beeService.save().then((data: any) => {
          this.template.beeplugin = true;
          this.template.json = data.jsonFile;
          this.template.html = data.htmlFile;
          this.saveDb(event);
        });
      } else {
        this.saveDb(event);
      }
    } else {
      this.messageService.add({ closable: false, severity: "error", detail: this.translateService.instant("general.form_incomplete") });
      return;
    }
  }
  cancel() {
    //this.tinyMceConfig.remove();
    this.showTinyMCE = false;
    this.dynamicDialogRef.close();
  }
  delete() {
    this.coreDialogService.confirm({
      message: this.translateService.instant("component.template.detail.delete_message", { name: this.template.name }),
      header: this.translateService.instant("general.confirmation_delete_title"),
      icon: "pi pi-info-circle",
      accept: () => {
        this.templatesService.delete(this.template.id).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: false, severity: 'success', detail: this.translateService.instant("general.confirmation_delete") });
            this.cancel();
          },
          error: (error: any) => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        })
      },
      reject: () => {

      }
    })
  }

  save_permissions(message) {
    this.buildMetadata();
    this.templatesService.savePermissions(this.template.id, this.template).subscribe({
      next: (data: any) => {
        this.messageService.add({ closable: false, severity: 'success', detail: message });
      },
      error: (error: any) => {
        this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
      }
    });
  }

  save_zone() {
    //Guarda zona en tabla y lo elimina del dropdown.
    if (this.selected_zone != null) {
      this.zones.splice(this.zones.lastIndexOf(this.selected_zone), 1);
      this.selected_zones.push(this.selected_zone);
      this.selected_zone = null;
      this.save_permissions(this.translateService.instant('component.templates.detail.zone_assign_correct'));
    }
  }
  unlinkZone(zone) {
    //Guarda la zona en dropdown y lo elimina de la tabla.
    var erased = this.selected_zones.splice(this.selected_zones.lastIndexOf(zone), 1);
    this.zones.push(erased[0]);
    this.selected_zone = { name: this.translateService.instant('component.template.detail.select_zone') };
    this.save_permissions(this.translateService.instant('component.template.detail.zone_rejected_correct'));
  }
  save_role() {
    if (this.selected_role != null) {
      this.roles.splice(this.roles.lastIndexOf(this.selected_role), 1);
      this.selected_roles.push(this.selected_role);
      this.selected_role = null;
      this.save_permissions(this.translateService.instant('component.template.detail.role_assign_correct'));
    }
  }
  unlinkRole(role) {
    var erased = this.selected_roles.splice(this.selected_roles.lastIndexOf(role), 1);
    this.roles.push(erased[0]);
    this.selected_role = { name: this.translateService.instant("component.template.detail.select_role") };
    this.save_permissions(this.translateService.instant('component.template.detail.role_rejected_correct'));
  }
  save_user() {
    if (this.selected_user != null) {
      this.users.splice(this.users.lastIndexOf(this.selected_user), 1);
      this.selected_users.push(this.selected_user);
      this.selected_user = null;
      this.save_permissions(this.translateService.instant('component.template.detail.user_assign_correct'));
    }
  }
  unlinkUser(user) {
    var erased = this.selected_users.splice(this.selected_users.lastIndexOf(user), 1);
    this.users.push(erased[0]);
    this.selected_user = { name: this.translateService.instant('component.template.detail.select_user') };
    this.save_permissions(this.translateService.instant('component.template.detail.user_rejected_correct'));
  }
  buildMetadata() {
    var finalZones = [];
    var finalUsers = [];
    var finalRoles = [];

    this.selected_zones.forEach(zone => {
      finalZones.push(zone.id);
    });
    this.selected_roles.forEach(role => {
      finalRoles.push(role.id);
    });
    this.selected_users.forEach(user => {
      finalUsers.push(user.id);
    });

    this.template.metadata = {
      permissions: {
        zones: finalZones,
        users: finalUsers,
        roles: finalRoles
      }
    }
  }

  loadMetadata() {
    var zonesIds = this.template.metadata["permissions"]["zones"];
    var usersIds = this.template.metadata["permissions"]["users"];
    var rolesIds = this.template.metadata["permissions"]["roles"];

    //Carga la tabla y dropdown de Usuarios:
    this.usersService.combo({}).subscribe(
      data => {
        var tempUsers = [];
        this.users = data.rows;
        this.users.forEach(user => {
          if (usersIds.indexOf(user.id) > -1) {
            this.selected_users.push(user);
          } else {
            tempUsers.push(user);
          }
          this.users = tempUsers;
        });
        /*this.selected_users = this.users.filter(function (e) {
          return usersIds.indexOf(e.id) > -1;
        });*/
      },
      error => {

      }
    );

    //Carga la tabla y dropdown de Zonas:
    if (this.zonesPermission) {

      this.zonesService.combo({}).subscribe({
        next: (data: any) => {
          var tempZones = [];
          this.zones = data.rows;
          this.zones.forEach(zone => {
            if (zonesIds.indexOf(zone.id) > -1) {
              this.selected_zones.push(zone);
            } else {
              tempZones.push(zone);
            }
            this.zones = tempZones;
          });

          /*this.selected_zones = this.zones.filter(function (e) {
            return zonesIds.indexOf(e.id) > -1;
          });*/
        },
        error: (error: any) => {

        }
      });
    }

    /*/Carga la tabla y dropdown de Roles:
    this.rolesService.getComboRoles({rolesIds: rolesIds}).subscribe(
      data=>{
        this.selected_roles = data.filter(function(element){
          return element.selected == true;
        });
        this.roles = data.filter(function(element){
          return element.selected != true;
        });
      }
    );*/
    this.rolesService.combo({}).subscribe({
      next: (data: any) => {
        var tempRoles = [];
        this.roles = data.rows;
        this.roles.forEach(role => {
          if (rolesIds.indexOf(role.id) > -1) {
            this.selected_roles.push(role);
          } else {
            tempRoles.push(role);
          }
          this.roles = tempRoles;
        });
        /*this.selected_roles = this.roles.filter(function (e) {
          return rolesIds.indexOf(e.id) > -1;
        });*/
      },
      error: (error: any) => {

      }
    });
  }

  previewHTML() {
    if (this.template.beeplugin == true) {
      this.beeService.save().then((data2: any) => {
        this.template.json = data2.jsonFile;
        this.template.html = data2.htmlFile;
        const ref = this.dialogService.open(HtmlPreviewComponent, {
          data: {
            temporal_template: this.template,
            entity_id: this.template.entity_id,
            entity_pk_id: 0
          },
          header: this.translateService.instant('component.templates.detail.previewed'),
          width: '70%',
        });
        ref.onClose.subscribe((data: any) => {
        });
      });
    } else {
      const ref = this.dialogService.open(HtmlPreviewComponent, {
        data: {
          temporal_template: this.template,
          entity_id: this.template.entity_id,
          entity_pk_id: 0
        },
        header: this.translateService.instant('component.templates.detail.previewed'),
        width: '70%',
      });
      ref.onClose.subscribe((data: any) => {
      });
    }
  }

  isDuplied(event) {
    if (this.template.id == null) {
      this.template.html = "<p></p>";
    }
    this.template.templatetype = null;
    //if (this.template.templatetype?.code != "MAIL") this.template.subject = null;
    if (!event.valid) {
      this.messageService.add({ closable: false, severity: "error", detail: this.translateService.instant("general.form_incomplete") });
      return;
    }
    this.templatesService.isDuplied(this.template).subscribe({
      next: (data: any) => {
        if (data == true) {
          this.coreDialogService.notify({
            message: this.translateService.instant('component.templates.detail.template_duplicate'),
            header: 'Error',
            icon: 'far exclamation-circle',
            color: 'var(--orange-500)',
            accept: () => { }
          });
        } else {
          this.save(event);
        }
      },
      error: (error: any) => {
        var message = "";
        for (var [key, value] of Object.entries(error.error.errors)) {
          message += value[0] + "\n\t";
        }
        if (message == "") message = error.error.title;
        this.messageService.add({ closable: false, severity: "error", detail: message });
      }
    });
  }
  duplicateTemplate() {
    //GUARDAMOS y Duplicamos la líneas de notification_to y notification_email.
    this.templatesService.save(this.template.id, this.template).subscribe({
      next: (data: any) => {

        this.templatesService.duplicateTemplate(this.template.id).subscribe({
          next: (data: any) => {
            this.cancel();

            let template_new = data;
            const ref = this.dialogService.open(TemplatesDetailComponent, {
              data: {
                id: template_new != null ? template_new.id : null,
                template_type_id: template_new.template_type_id
              },
              header: template_new != null ? this.translateService.instant('component.templates.detail.detail_entity') : this.translateService.instant('component.templates.detail.new_entity'),
              width: '70%'
            });
            ref.onClose.subscribe((data: any) => {
              this.view.fireEvent("templates.list.results", "reload");
            });
          }
        });
      },
      error: (error: any) => {
        this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
      }
    })

  }

  getHtml() {
    let a = document.createElement("a");
    let dataURI = "data:text/plain;base64," + this.btoaUtf8(this.template.html);
    a.href = dataURI;
    a['download'] = this.template.name.replace(/\s/g, '_') + ".html";
    a.click();
    a.remove();
  }

  btoaUtf8(str: string): string {
  return btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
      return String.fromCharCode(parseInt(p1, 16));
    })
  );
}

  /*changeCode(templatetype) {
    this.template.templatetype = templatetype;
    if (templatetype.code == "DOCUMENT") this.template.subject = "";
  }
  */
  onEvent(event) {

    if (event.component == "templates.edit.general") {
      if (event.event == "action" && event.action.name == "delete") this.delete();
      if (event.event == "action" && event.action.name == "cancel") this.cancel();
      if (event.event == "action" && event.action.name == "save") this.isDuplied(event);
      if (event.event == "action" && event.action.name == "preview") this.previewHTML();
      if (event.event == "action" && event.action.name == "duplicate") this.duplicateTemplate();
      if (event.event == "onChange" && event.entityField?.model_property == "template_type_id") {
        //this.changeCode(this.templateTypes.filter(m => m.id == event.data.template_type_id)[0]);
      }
    }


    if (event.component == "view" && event.event == "entity-loaded") {
      this.config.header = typeof (this.template.id) !== "undefined" ? this.translateService.instant("component.templates.detail.detail_entity", { entity_name: this.view.getEntityBaseName() }) : this.translateService.instant("component.templates.detail.new_entity", { entity_name: this.view.getEntityBaseName() });
    }
  }
}
